import { Component, OnInit, Input } from '@angular/core';
import { pgiAuthors } from 'src/app/models/authors';
import { AuthorsService } from 'src/app/shared/authors/authors.service';

@Component({
  selector: 'app-authors-list',
  templateUrl: './authors-list.component.html',
  styleUrls: ['./authors-list.component.css']
})
export class AuthorsListComponent implements OnInit {
  authors: pgiAuthors[];
  selectedValue: string;
  constructor(private authorService: AuthorsService) { }

  ngOnInit() {
    this.getAuthors();
  }

  getAuthors(): void {
    this.authorService.getAuthorsList().subscribe((authors => this.authors = authors) );
  }
}
